module.exports = __webpack_public_path__ + "static/media/99.1bc10746.jpg";